<template>
    <AdmPanel>
        <h2 slot="header_title">排行榜</h2>
        <div slot="header_buttons" class="adm-buttons">
           <iv-button
            v-if="isAudit"
            slot="header_buttons"
            type="primary"
            ghost
            @click="modal.release.data.year=conditions.year; modal.release.shown=true"
          >
            <iv-icon type="md-checkbox-outline" size="14" />
            <span> 发布榜单结果</span>
          </iv-button>
           <iv-button
              v-rbac-allow="['carbonScore','export']"
              class="export-excel-btn"
              :loading="loader[SCORERANK+'export']"
              @click="exportExcel()"
            >
              <iv-icon type="ios-cloud-download" size="14" />
              <span> 导出</span>
            </iv-button>
        </div>
        <div class="filter-wrapper" v-loading="loader[SCORERANK+'fetch']">
            <FilterBar :value="conditions" :condition="options.filter_rules">
              <iv-form-item>
                <span class="adm-buttons">
                  <iv-button :disabled="loader[SCORERANK+'fetch']" type="info"
                    @click="changeQuery(mergeQuery({ ...conditions }))">
                    <iv-icon type="ios-search" size="14" style="vertical-align:text-bottom" /> 查询 </iv-button>
                </span>
              </iv-form-item>
            </FilterBar>
          <!-- <div class="adm-panel__tools checked-list">
              <span class="checked-list__title" style="width:5em;text-align: right;">按企业：</span>
              <iv-tag
                v-for="item in conditions.stockCodeList"
                type="border"
                :key="item.stockCode"
                :name="item.stockCode"
                closable
                @on-close="removeConditioner('stockCodeList', item, 'stockCode')"
                >{{ item.abbreviation }}</iv-tag>
              <iv-select
                  ref="companySelection"
                  style="width:150px"
                  :value="sources.companyFake"
                  filterable
                  clearable
                  :placeholder="'企业名称/股票号'"
                  @on-change="onCompanyChanged"
              >
                  <template
                      v-for="item in options.companys">
                    <iv-option
                      v-if="conditions.industryList.length > 0 ? item.industryList.some(industry=>conditions.industryList.indexOf(industry.industryId)>-1) : true"
                      :value="item.stockCode"
                      :key="item.stockCode">
                      {{ item.abbreviation }}
                    </iv-option>
                  </template>
              </iv-select>
          </div> -->
        </div>
        <iv-table
                class="adm-table"
                :columns="columns"
                :loading="loader[SCORERANK+'fetch']"
                :data="list.data"
                @on-sort-change="SortList"
                @on-selection-change="onTableSelected">
        </iv-table>
        <template v-if="list.last_page > 1">
            <div slot="footer" class="pull-right">
                <iv-page
                        @on-change="pageChanged"
                        :current="list.current_page"
                        :page-size="10"
                        show-elevator
                        show-total
                        :total="list.total">
                </iv-page>
            </div>
        </template>
        <iv-modal
          :mask-closable="false"
          title="发布榜单结果"
          width="450"
          :closable="false"
          v-model="modal.release.shown"
          @on-cancel="modal.release.shown = false">
          <iv-form label-position="left" :label-width="120">
              <iv-form-item label="榜单项目年" prop="year">
                  <iv-select v-model="modal.release.data.year">
                    <iv-option
                      v-for="year in options.year"
                      :key="year.id"
                      :value="year.id"
                      >{{ year.title }}</iv-option>
                  </iv-select>
              </iv-form-item>
              <iv-form-item label="总榜对外展示日期" prop="rankDisplayTime">
                  <iv-date-picker
                    type="datetime"
                    placeholder="选择日期和时间"
                    v-model="modal.release.data.rankDisplayTime"
                  />
              </iv-form-item>
              <iv-form-item label="子榜对外展示日期" prop="subRankDisplayTime">
                  <iv-date-picker
                    type="datetime"
                    placeholder="选择日期和时间"
                    v-model="modal.release.data.subRankDisplayTime"
                  />
              </iv-form-item>
          </iv-form>
          <iv-alert show-icon>系统将发布上述项目年的已审核数据到外部展示平台，请认真确认数据无误后再进行发布操作</iv-alert>
          <iv-button type="text" size="large" slot="footer" @click="modal.release.shown = false;modal.release.data.year=conditions.year">取消</iv-button>
          <iv-button type="primary" size="large" slot="footer" @click="publish(modal.release.data)">发布</iv-button>
        </iv-modal>
    </AdmPanel>
</template>
<script>
import { RELEASE_TASKS,RELEASE_ADD_POLLING_TASK } from "@/stores/modules/release"
import { mapActions, mapGetters } from 'vuex';

import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";

import contact from "@/utils/contact";
import { conditioner, defaultVal, unique, downloadByUrl, carbon_years, getProductYear } from '@/utils/';

import FilterBar from "@/components/FilterBar_X2";
import CheckedList from "@/components/CheckedList";

import CarbonScorerankModel  from '@/models/CarbonScorerankModel';
import CarbonIndustryModel from "@/models/CarbonIndustryModel";
import CarbonCompanyModel    from '@/models/CarbonCompanyModel'
import ReleaseModel    from '@/models/ReleaseModel'

import fecha from "fecha"

const _years = carbon_years().map(year=>({...year, title:year.name}))
const options = {
    statistics:[
      {id : '0', title: '全部数据'},
      {id : '1', title: '已审核且通过数据'},
    ],
    dataSource:[
      {id : '0', title: '新录入数据'},
      {id : '1', title: '发布数据'},
      {id : '1', title: '已审核数据'},
    ]
}
const filter_rules = [
    // {name: 'statistics', type: "Select", options: options.statistics, title: '统计范围', default: "", placeholder: "统计范围",style: { width: "140px" }},
     { name: "year", type: "Select", options: _years, title: "年份", default: "", placeholder: "年份", style: { width:
     "100px" } },
    { name: "industryId", type: "Select", options: [], title: "行业", default: "", placeholder: "行业", clearable: true, style: { width:
     "150px" } },
    { name: 'stockCode', type: 'Select', options: [], title: '公司', default: '', placeholder: '公司', filterable: true,
     clearable: true, style: { width: '150px' } },
    { name: "dataSource", type: "Select", options: options.dataSource, title: "数据来源", default: "", placeholder: "数据来源",
    style: { width: "150px" } },
]
const _conditioner = conditioner(
    {//ui到url
      limit           : {type: Number, default: 10},
      // industryList    : {type: val=>  JSON.stringify(val) , default: ()=>[]},
      // stockCodeList   : {type: val=>  JSON.stringify(val.map(item=>item.stockCode)) , default: ()=>[]},
      // statistics      : {type: String , default: ''},
      dataSource      : {type: String , default: ''},
      year: { type: Number, default: null },
      industryId: { type: Number, default: null },
      stockCode: { type: String, default: '' },
    },
    {//url到ui
      limit           : {type: Number, default: 10},
      // industryList    : {type: val=>  JSON.parse(val) , default: ()=>[]},
      // stockCodeList   : {type: val=>  JSON.parse(val) , default: ()=>[]},
      // year            : {type: Number , default: ()=>getProductYear()},
      // statistics      : {type: String , default: ''},
      dataSource      : {type: String , default: ''},
      year: { type: val => parseInt(val), default: () => _years[0].id },
      industryId: { type: Number, default: null },
      stockCode: { type: String, default: '' },
    }
)


const COMPANY = CarbonCompanyModel.ModelName;
const SCORERANK = CarbonScorerankModel.ModelName
const INDUSTRY = CarbonIndustryModel.ModelName
const RELEASE = ReleaseModel.ModelName

export default {
        name: "public_sentiment",
        mixins:[
            LoaderMixin(COMPANY, SCORERANK, SCORERANK+'fetch', SCORERANK+'export', INDUSTRY, RELEASE),
            ModelMixin({
                contact,
                models:[
                    CarbonCompanyModel,
                    CarbonScorerankModel,
                    CarbonIndustryModel,
                    ReleaseModel
                ]
            })
        ],
        data() {
            return {
                columns: [],
                conditions: _conditioner.default(),
                SCORERANK,
                INDUSTRY,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    companys: [],
                    industry:[],
                    filter_rules,
                    year: _years
                },
                secondTarget:'',
                sources:{
                    loading:false,
                    companyFake:''
                },
                modal: {
                  release: {
                    shown: false,
                    data: {
                      year: "",
                      rankDisplayTime: fecha.parse(fecha.format(new Date, "YYYY-MM-DD"), "YYYY-MM-DD 00:00:00"),
                      subRankDisplayTime: fecha.parse(fecha.format(new Date, "YYYY-MM-DD"), "YYYY-MM-DD 00:00:00"),
                    }
                  }
                },
                selection: {
                  list: [],
                  comment: "",
                  shown: false,
                  shown2: false,
                },
            }
        },
        async mounted () {
            const { query, params } = this.$route
            let conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式
            let parse_conditions = _conditioner.parse(conditions)
            this.conditions.year = defaultVal( this.conditions.year, getProductYear());
            const industries = await this.refreshIndustry(conditions.year)
            conditions.industryId = conditions.industryId ? conditions.industryId : industries[0].id
            const companys = await this.refreshCompanys(conditions.industryId)
            this.renderFilterBar('industryId', industries)
            this.renderFilterBar('stockCode', companys)
            conditions.statistics =conditions.statistics ? conditions.statistics : (this.isAudit ? '1': '0')
            this.conditions = conditions
            this.$nextTick(()=>{
                this.refresh(conditions)
            })
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async ()=>{
              const { query, params } = to
              let conditions = {
                ..._conditioner.default(),
                ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
              }
              conditions.year = defaultVal( this.conditions.year, getProductYear());
              let parse_conditions = _conditioner.parse(conditions)
              // await this.refreshIndustry(parse_conditions.year)

              // conditions.stockCodeList = this.serializeCompany(conditions.stockCodeList)
              conditions.statistics =conditions.statistics ? conditions.statistics : (this.isAudit ? '1': '0')
              this.conditions = conditions
              this.refresh()
            })
            next();
        },
        methods: {
            ...mapActions([RELEASE_ADD_POLLING_TASK]),
            async refresh(query=this.conditions){
                const result = await this.$$fetch(SCORERANK, _conditioner.parse({...query, type: 'scoreRank'}));
                if(result instanceof Error) return
                this.list.data = result.data.data
                this.list.total = result.total
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1;
                this.list.last_page = result.total / _conditioner.parse(query).limit;
                this.columns = result.data.columns.map(column=>({
                  align: "left",
                  minWidth: 120,
                  ...column,
                }))
            },
            async refreshCompanys (industryId) {
              const company = await this.$$fetch(COMPANY, { industryId: industryId })
              return (this.options.companys = company.data.map(item => ({ id: item.stockCode, name: item.stockCode + ' ' + item.abbreviation })))
            },
            async refreshIndustry (year) {
              const industry = await this.$$fetch(INDUSTRY, {year: year})
              if (industry) this.options.industry = industry.data.map(item => ({ ...item, name: item.industry }))
              return this.options.industry
            },
            renderFilterBar (fieldName, val, defaults) {
              const fieldset = this.options.filter_rules.find(fieldset => fieldset.name === fieldName)
              fieldset.options = val
            },
            onCompanyChanged(stockCode){
              this.sources.companyFake = ""
              this.$refs.companySelection.clearSingleSelect()
              const company = this.options.companys.find(item=>item.stockCode == stockCode)
              // if(company) this.conditions.stockCodeList = unique([...this.conditions.stockCodeList, company], 'stockCode')
              if(company) this.changeQuery(this.mergeQuery({ stockCodeList:[...unique([...this.conditions.stockCodeList, company], 'stockCode')], offset:0 }))
            },
            Search(val){
                if(!val) this.conditions.industryList = []
                else{
                    if(this.conditions.industryList.indexOf(val.id) > -1)
                        this.conditions.industryList.splice(this.conditions.industryList.indexOf(val.id),1)
                    else
                        this.conditions.industryList.push(val.id)
                }
                this.changeQuery()
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            mergeQuery(query){
              return { ...this.conditions, ...query}
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse(query)},
                    params: params
                });
            },
            removeConditioner(fieldName, removeItem, keyField="id"){

              const list = [...this.conditions[fieldName]]
              const index = list.findIndex(item=>item[keyField]==removeItem[keyField])
              list.splice(index,1)
              this.changeQuery(this.mergeQuery({ [fieldName]: list, offset:0 }))
            },
            parseQuery(params, filter=[]){
              const { company } = { ...params }
              const query = {
                stockCodeList: company.map(item=>item.stockCode),
              }
              return Object.keys(query).filter(key=>filter.indexOf(key)).reduce((result, key)=>({ ...result, [key]:query[key] }),{})
            },
            async exportExcel(query = this.conditions) {
              // console.log({..._conditioner.parse(query)})
              // const res = await exportReportExcel({..._conditioner.parse(query)})
              const res = await this.$$active(SCORERANK, 'export',{..._conditioner.parse({ ...query, type: 'scoreRank' })})
              console.log("exportExcel...", res)
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              // 下载链接
              downloadByUrl(res.data.url)
            },
            serializeCompany(ids, companys=this.options.companys){
              return companys.filter(item=>ids.indexOf(item.stockCode)>-1)
            },
            publish(data){
              this
                .$$active(RELEASE, 'publish', { type: 'carbon', ...data })
                .then(res=>{
                  const { id } = res.data
                  this[RELEASE_ADD_POLLING_TASK]({id, group:this.$route.name})
                  this.modal.release.shown = false
                })
            },
            SortList(val) {
              this.conditions.ordering = val.order == "normal" ? "" : val.order == "desc" ? `-${val.key}` : val.key;
              this.changeQuery();
            },
            onTableSelected(selection){
              this.selection.list = selection
            },
        },
        watch:{
            // async ['conditions.stockCodeList'](company){
            //     this.sources.loading = true
            //     await this.refresh(this.parseQuery({ company }))
            //     this.$nextTick(()=>this.sources.loading = false)
            // },
            // async ['conditions.industryList'](val){
            //     this.conditions.stockCodeList = []
            //     await this.refreshCompanys(val)
            //     await this.refresh()
            // }
             'conditions.year': {
              async handler (newVal, oldVal) {
                if (oldVal) {
                  let industries = await this.refreshIndustry(newVal)
                  this.renderFilterBar('industryId', industries)
                }
                const conditions = _conditioner.parse({ year:newVal })
                this.modal.release.data.year=conditions.year
              }
            },
            'conditions.industryId': {
              async handler (newVal, oldVal) {
                if (oldVal) {
                  let companys = await this.refreshCompanys(newVal)
                  this.renderFilterBar('stockCode', companys)
                }
              }
            }
        },
        computed: {
          ...mapGetters([RELEASE_TASKS]),
          isAudit(){
            return this.$route.matched.some(item=>item.name=='audit')
          }
        },
        components:{
            FilterBar,
            CheckedList
        }
    }
</script>
<style lang="scss" scoped>
.checked-list{
  margin-top:-10px;
  display:flex;
  align-items: baseline;
  @media screen and (min-width: 768px) {
    display: flex;
  }
  &__title{
    flex-shrink: 0;
    margin-right: 5px;
    margin-bottom: 10px;
    display: block;
    @media screen and (min-width: 768px) {
      text-align: right;
    }
  }
  &__body{
    flex-grow: 1;
    > * {
      margin-bottom: 5px;
    }
  }
}
.filter-wrapper {
  position: relative;
  .export-excel-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
